/** Obfuscation des liens */
 export function obfuscate() {
    const obfuscatedLinks = document.querySelectorAll('.ob-link');
    obfuscatedLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            obfuscatedLinkedClicked(link);
        });

        link.addEventListener('keydown', (e) => {
            const keyCode = e.keyCode;
            if(keyCode === 13) { // Enter
                obfuscatedLinkedClicked(link);
            }
        });
    });
}

/**
 * Ouvre le lien obfusqué
 *
 * @param {Element} link
 */
function obfuscatedLinkedClicked(link) {
    console.log(link);
    const encodedHref = link.dataset.aim;
    const href = b64DecodeUnicode(encodedHref);
    const blank = link.dataset.ext === '_blank';

    window.open(href, blank ? '_blank' : '_self');
}

/**
 * Décode une chaine de caractères en base64 avec caractères spéciaux
 *
 * @see https://stackoverflow.com/a/30106551
 * @param {string} base64Text encoded text
 * @returns string decoded text
 */
function b64DecodeUnicode(base64Text) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(base64Text).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}